module.exports = __webpack_public_path__ + "media/newstyle/images/logo-mercado-944a386ec184824b80eba830e66137c0.png";